import Select2 from './Select2';

export default Select2;